module.exports = {
    lang: 'ru',

    selectLang: {
        href: {
            ru: '/ru/data/',
            en: '/en/data/',
        },
        engTitle: 'Английский',
        ruTitle: 'Русский'
    },

    socialList: {
        facebook: {
            link: '',
            isVisible: false
        },
        vk: {
            link: 'https://vk.com/bigdealforbusiness',
            isVisible: true
        },
        inst: {
            link: 'https://www.instagram.com/bigdeal.agency/',
            isVisible: true
        },
        git: {
            link: '',
            isVisible: false
        },
        be: {
            link: '',
            isVisible: false
        },
        dribbble: {
            link: '',
            isVisible: false
        },
    },

    landBotChats: {
        easyModeChat: 'https://landbot.io/u/H-68476-1A2CWEOM36J1XGSJ/index.html',
        careerChat: 'https://landbot.io/u/H-70435-LIYLO5LTAGMDIG2R/index.html',
        contactsChat: 'https://landbot.io/u/H-70201-5R3AV4JT14LQQ85S/index.html'
    },

    footerInfo: {
        cookiesPolicy: 'Политика Cookie',
        terms: 'Условия использования',
        privacyPolicy: 'Политика обработки персональных данных'
    },

    choiceTabs: {
        modes: {
            easy: 'Простой режим',
            hard: 'Сложный режим'
        }
    },

    buttonBack: 'Назад',
    buttonStartChat: 'Написать',
    buttonCloseChat: 'Закрыть чат',

    headerMenu: {
        'link-1': 'О нас',
        'link-2': 'Концепция',
        'link-3': 'Карьера',
        'link-4': 'Контакты',
    },

    INDEX: {
        headful: {
            title: 'BigDeal Agency: Мы помогаем брендам продвигаться в онлайне',
            description: 'Вы хотите продвигать свой бренд или развивать бизнес в Интернете? BigDeal Agency поможет вашей компании продвигаться в сети. Узнайте больше сейчас!'
        },

        startPageText: {
            title: 'Продвижение <br/> <span class="white-space-nowrap">брендов онлайн</span>',
            desc: 'В 21  веке большинство людей уже забыли про традиционный шоппинг. Наличие интернет-магазина стало неотъемлемой частью любого бизнеса. Расширьте свою целевую аудиторию, получите дополнительный доход и позвольте людям узнать о вас!',
        },

        learnMoreTxt: 'Узнать больше',

        startPageTextImg: '<div>Расслабься, милая!</div><div>Скоро ты появишься онлайн...</div>',

        textSaying: {
            neanderthal: 'Расскажи мне об этом, адская машина!',
            lolman: 'Ну-ну. Расскажи мне об этом!',
            aristotle: 'Я лучше прочитаю это сам'
        },

        route: {

            '/': {
                title: 'Продвижение <br/> брендов в онлайне',
                nextButton: 'Прокрутите вниз, чтобы увидеть больше'
            },

            'choice': {
                infoBlock: {
                    title: 'Сделай <br/> свой выбор',
                    desc: 'Настало время решать. Вы хотите узнать больше о наших услугах самостоятельно? Тогда выбирайте сложный режим. Или же вы можете выбрать простой режим. В этом случае, запасайтесь чашечкой чая, садитесь на диван и начинайте чатиться с нашим ботом. Он с удовольствием ответит на все ваши вопросы.'
                },
                insult: 'Изображение неандертальца оскорбляет меня',
                nextButton: {
                    stepText: {
                        startText: 'Начать',
                        modeText: 'режим'
                    },
                    mode: {
                        easy: 'простой',
                        hard: 'сложный'
                    },
                    close: 'Закрыть чат'
                }
            }

        }
    },

    ABOUT: {
        headful: {
            title: 'BigDeal Agency: Готовы сделать мир ярче?',
            description: 'Мы - рекламное агентство, которое помогает бизнесу привлекать новых клиентов и развивать онлайн-услуги. Узнайте больше о нашей работе.'
        },

        route: {
            '/': {
                infoBlock: {
                    title: 'Вот это пушка',
                    desc: 'Мы - рекламное агентство, которое помогает в привлечении новых клиентов и занимается разработкой онлайн-услуг. Расскажите нам о своих целях, и мы разработаем стратегию цифрового маркетинга, создадим бренд и предоставим вам безупречный дизайн.'
                }
            },
            'two': {
                infoBlock: {
                    title: '<span class="white-space-nowrap">Универсальность -</span> наш конек',
                    desc: 'Наша страсть - это цифровые технологии. Не важно какой у вас бизнес - мы сделаем все возможное. Если вы хотите вывести бизнес в онлайн, мы разработаем фирменный стиль, привлечем клиентов и настроим софт для отслеживания эффективности кампаний.',
                    links: {
                        'learn-more': 'Узнать больше',
                        'link-1': 'Брендинг',
                        'link-2': 'Увеличение продаж',
                        'link-3': 'Расширение бизнеса'
                    }
                },
                _child: {
                    branding: {
                        title: 'Люди узнают о вас',
                        desc: 'Мы проводим брендинг в 3 этапа. Сначала мы занимаемся проработкой стратегии и продумываем все детали. Затем мы разрабатываем название и фирменный стиль. И наш последний этап - рассказать всем о вашем бренде. Проще говоря, позаботиться о том, чтобы люди о вас узнали.',
                        list: {
                            title: 'Наши услуги:',
                            items: [{
                                    label: 'Бренд-стратегия'
                                },
                                {
                                    label: 'Нэйминг'
                                },
                                {
                                    label: 'Фирменный стиль'
                                },
                                {
                                    label: 'Медиабаинг'
                                },
                                {
                                    label: 'SMM'
                                },
                                {
                                    label: 'SEO'
                                },
                            ]
                        }
                    },
                    businessExpansion: {
                        title: 'Из офлайна в онлайн',
                        desc: 'Расширение бизнеса - это комплексный подход, позволяющий вывести бизнес в онлайн. Мы подключим и настроим CRM, выстроим воронку продаж и наладим бизнес-аналитику. Наши знания и технологии позволят вам успешно конкурировать в интернете.',
                        list: {
                            title: 'Наши услуги:',
                            items: [{
                                    label: 'Формирование отдела продаж'
                                },
                                {
                                    label: 'Сквозная бизнес-аналитика'
                                },
                                {
                                    label: 'Построение воронки продаж'
                                },
                                {
                                    label: 'Настройка собственной панели администратора'
                                },
                                {
                                    label: 'Собственная настройка CRM'
                                },
                            ]
                        }
                    },
                    salesActivation: {
                        title: 'Увеличьте свои продажи в мгновенье ока',
                        desc: 'Мы предлагаем комплексный подход к увеличению продаж. Среди наших клиентов – интернет-магазины, разработчики игр, и технологические компании. Специалисты BigDeal Agency всегда рады взяться за интересный проект в любой сфере. Мы позаботимся об увеличении ваших продаж. ',
                        list: {
                            title: 'Наши услуги:',
                            items: [{
                                    label: 'Разработка промо материалов'
                                },
                                {
                                    label: 'Лидогенерация'
                                },
                                {
                                    label: 'Поисковая реклама'
                                },
                                {
                                    label: 'Имейл-маркетинг'
                                },
                            ]
                        }
                    },
                }
            },
            'three': {
                infoBlock: {
                    title: "<span class='white-space-nowrap'>мы готовы принять</span> вызов",
                    desc: 'Основа успешной кампании - это детально разработанный план. За 8 лет работы мы столкнулись с различными трудностями. Их было бы гораздо больше, если бы не тщательное планирование. Благодаря нашим планам, мы достигаем ожидаемых результатов и делаем работу качественно.',
                    links: {
                        'link-1': 'Концепция',
                        'learn-more': 'Узнать больше'
                    }
                },
            }
        }
    },

    VISION: {
        progressLineTitle: ['Начало времени', 'Миллион лет'],
        headful: {
            title: 'BigDeal Agency: Планирование — наше всё',
            description: 'Планирование - краеугольный камень нашей работы. Люди выбирают нас, потому что мы заботимся о всех этапах работы и гарантируем измеримый результат.'
        },

        infoBlock: {
            text: 'До успеха',
            years: 'Million years'
        },

        route: {
            '/': {
                infoBlock: {
                    title: 'Все о <br/> планировании',
                    desc: 'Мы не обещаем вам розарий, а обещаем только одну вещь. Мы разработаем план создания вашего собственного розария. Люди выбирают нас, поэтому что мы заботимся о каждом этапе своей работы. А также гарантируем результат, который можно измерить. Ниже представлены 6 основных этапов нашей работы.'
                }
            },
            'one': {
                infoBlock: {
                    // title: 'Develop <br> <span class="white-space-nowrap">a Media Plan</span>',
                    title: 'Создать <br/> медиаплан',
                    desc: 'Медиаплан - это карта сокровищ для успешной кампании. Прямой как палка, отвечающий на главные вопросы: когда начинать кампанию, где размещать рекламу и сколько это стоит. Мы  чертовски серьезны насчет этого шага, поскольку именно он формирует проект и устанавливает задачи. '
                }
            },
            'two': {
                infoBlock: {
                    title: 'Проанализировать <br/> конкурентов',
                    desc: 'Кто ваши конкуренты? Какие у них слабые места? Как они могут вас обогнать? Наша команда  будет готова заглянуть в любой шкаф, чтобы найти там скелет. Объедините эти данные с медиапланом и вы получите  информацию о потайной тропке на пути к своей цели.'
                }
            },
            'three': {
                infoBlock: {
                    title: 'Разработать <br> стратегию',
                    desc: 'Медиаплан описывает куда мы идем. Стратегия объясняет, как мы туда доберемся. Стратегия разбивает медиаплан на двухнедельные спринты.  Каждый член команды получает задания, рекомендации по выполнению и дедлайны для сдачи. Это гарантирует то, что команда работает как единый механизм и обеспечит качественный результат. '
                }
            },
            'four': {
                infoBlock: {
                    title: 'Собрать <br/> команду',
                    desc: 'Правильный человек - ключ к успеху. Мы выбираем членов команды в соответствии с их опытом в конкретной вертикали продукта. Ведь те, кто продвигают игры, могут ничего не смыслить в продвижении финансовых продуктов. Для каждого проекта мы согласовываем с клиентом список выбранных специалистов, включая и персонального менеджера. '
                }
            },
            'five': {
                infoBlock: {
                    // title: 'Run a Test. <br> <span class="white-space-nowrap">Run One More</span>',
                    title: 'Тест за тестом',
                    desc: 'Сначала мы всегда тестируем. Планы и стратегии это прекрасно, но реальная жизнь куда суровее. Этот этап включает в себя тщательное тестирование, которое покажет предварительные результаты. Тест даст возможность объективно оценить проделанную работу и определить места, где ее можно улучшить.'
                }
            },
            'six': {
                infoBlock: {
                    title: 'Достичь результатов',
                    desc: 'Наши доходы зависят от вашей прибыли. Вы платите только в том случае, если мы достигли результатов, описанных в медиаплане. Например, увеличение дохода показывает результат услуги “Активация продаж”. А повышение упоминаний бренда в социальных сетях покажет результат услуги “Брендинг”. '
                }
            }
        }
    },

    CAREER: {
        headful: {
            title: 'BigDeal Agency: мы ищем таланты!',
            description: 'Наша позитивная и дружелюбная команда ищет новых тиммейтов. Если вы считаете, что подходите нам, мы с удовольствием рассмотрим вашу кандидатуру.'
        },

        route: {
            '/': {
                infoBlock: {
                    title: `<span class="white-space-nowrap">Смелый, честный,</span> <br>
                            <span class="white-space-nowrap">и готовый</span> <br>
                            <span class="white-space-nowrap">принять вызов</span>`,
                    desc: 'Наша позитивная и дружелюбная команда ищет новых тиммейтов. Если вы считаете, что подходите нам, мы с удовольствием рассмотрим вашу кандидатуру. Отправьте свое резюме нам на почту: hh@bigdeal.agency.  Ждем вас в BigDeal Agency!',
                    links: {
                        'learn-more': 'узнать больше',
                        'link-1': 'HTML-верстальщик',
                        'link-2': 'Менеджер по работе <br/> с иностранными клиентами',
                        'link-3': 'Специалист отдела маркетинга <br/> и внешних связей',
                        'link-4': 'Младший специалист <br/> по арбитражу интернет-трафика',
                        'link-5': 'Менеджер по продажам',
                        'link-6': 'Мне нужна другая вакансия',
                    }
                },

                _child: {
                    careerPageOne: {
                        title: 'Front-End Developer',
                        lists: [{
                                list: {
                                    title: 'Минимальные Требования:',
                                    items: [{
                                            label: 'HTTP5, CSS/CSS3;'
                                        },
                                        {
                                            label: 'Основы JavaScript (необходимо понимать, как работают чужие скрипты, а также писать свои (для начала простые);'
                                        },
                                        {
                                            label: 'jQuery.'
                                        },
                                    ]
                                },
                            },
                            {
                                list: {
                                    title: 'Рекомендуемые требования:',
                                    items: [{
                                            label: 'Понимание различий в браузерах, кроссбраузерная верстка; '
                                        },
                                        {
                                            label: 'Знание основ PHP;'
                                        },
                                        {
                                            label: 'Знание и понимание принципов работы веб-браузеров (необходимо для оптимизации лендингов).'
                                        },
                                    ]
                                },
                            },
                            {
                                list: {
                                    title: 'Чем предстоит заниматься:',
                                    items: [{
                                            label: 'Создавать лендинги с нуля (и мобильных), редактировать лендинги; '
                                        },
                                        {
                                            label: 'Использовать в работе скрипты для мобильных лендингов;'
                                        },
                                        {
                                            label: 'Дизайн.'
                                        },
                                    ]
                                },
                            },
                            {
                                list: {
                                    title: 'Мы предлагаем:',
                                    items: [{
                                            label: 'Стабильная заработная плата по результатам собеседования, перспектива карьерного роста;​​​​​​​ '
                                        },
                                        {
                                            label: 'Оформление по ТК РФ и полностью «белая» заработная плата;'
                                        },
                                        {
                                            label: 'Просторный и современный офис (район Древлянка-Перевалка);'
                                        },
                                        {
                                            label: 'Работа только на постоянной основе и только в офисе (варианты удаленного или краткосрочного сотрудничества не рассматриваем).'
                                        },
                                    ]
                                },
                            },
                        ],
                    },

                    CareerPageTwo: {
                        title: 'Менеджер по работе с иностранными клиентами со знанием английского языка ',
                        lists: [{
                                list: {
                                    title: 'Мы будем рады видеть вас в нашей команде, если вы:',
                                    items: [{
                                            label: 'Имеете высшее образование;'
                                        },
                                        {
                                            label: 'Свободно владеете английским языком (грамотной устной и письменной речью);'
                                        },
                                        {
                                            label: 'Знаете ПК на уровне продвинутого пользователя.'
                                        },
                                    ]
                                },
                            },
                            {
                                list: {
                                    title: 'Чем предстоит заниматься: <br/> <span class="small">Сразу:</span>',
                                    items: [{
                                            label: 'Взаимодействовать с иностранными клиентами, вести деловые переговоры (начиная с переписки и заканчивая личными встречами);'
                                        },
                                        {
                                            label: 'Вести проекты, контролировать исполнение поставленных задач по проекту;'
                                        },
                                        {
                                            label: 'Вести ежедневную отчетность.'
                                        },
                                    ]
                                },
                            },
                            {
                                list: {
                                    title: '<span class="small">В перспективе:</span>',
                                    items: [{
                                            label: 'Посещать конференции, выставки по всему миру;'
                                        },
                                        {
                                            label: 'Встречаться с самыми успешными и интересными людьми в бизнесе;'
                                        },
                                        {
                                            label: 'Строить карьеру, многократно увеличивая свою ценность как профессионала.'
                                        },
                                    ]
                                },
                            },
                            {
                                list: {
                                    title: 'Мы ценим в своих сотрудниках:',
                                    items: [{
                                            label: 'Умение сосредоточиться на задаче;'
                                        },
                                        {
                                            label: 'Умение довести дело до конца;'
                                        },
                                        {
                                            label: 'Способность обучаться самостоятельно посредством учебных пособий, инструкций и методичек;'
                                        },
                                        {
                                            label: 'Способность работать в высоком темпе;'
                                        },
                                        {
                                            label: 'Умение планировать свой день;'
                                        },
                                        {
                                            label: 'Интерес к маркетингу в общем и интернет-маркетингу в частности, во всем его многообразии;'
                                        },
                                        {
                                            label: 'Желание расти и развиваться, получать новые знания.'
                                        },
                                    ]
                                },
                            },
                            {
                                list: {
                                    title: 'Мы предлагаем:',
                                    items: [{
                                            label: 'Стабильная заработная плата по результатам собеседования, перспектива карьерного роста​​​​​;'
                                        },
                                        {
                                            label: 'Оформление по ТК РФ и полностью «белая» заработная плата;'
                                        },
                                        {
                                            label: 'Гибкий график работы Пн-Пт. с 10 до 19 часов (обсуждается на собеседовании);'
                                        },
                                        {
                                            label: 'Просторный и современный офис (район Древлянка-Перевалка);'
                                        },
                                        {
                                            label: 'Работа только на постоянной основе и только в офисе (варианты удаленного или краткосрочного сотрудничества не рассматриваем).'
                                        },
                                    ]
                                },
                            },
                        ],
                    },

                    CareerPageThree: {
                        title: 'Специалист отдела маркетинга и внешних связей',
                        lists: [{
                                list: {
                                    title: 'Чем предстоит заниматься:',
                                    items: [{
                                            label: 'Ведение переговоров с клиентами по вопросам продажи/покупки рекламы;'
                                        },
                                        {
                                            label: 'Постпродажное сопровождение процессов, участие в реализации стартапов;'
                                        },
                                        {
                                            label: 'Проектная работа в команде.'
                                        },
                                    ]
                                },
                            },
                            {
                                list: {
                                    title: 'Идеальный кандидат "must have":',
                                    items: [{
                                            label: 'Высшее образование по смежной специальности;'
                                        },
                                        {
                                            label: 'Знание Английского языка на уровне Intermediate;'
                                        },
                                        {
                                            label: 'Знание ПК на уровне продвинутого пользователя;'
                                        },
                                        {
                                            label: 'Опыт работы в сфере продаж;'
                                        },
                                        {
                                            label: 'Способность к самоорганизации и самообучению посредством предоставленных материалов/методичек.'
                                        },
                                    ]
                                },
                                text_end: '<i>Ключевые качества, которыми должен обладать наш будущий сотрудник: самостоятельное мышление, внутренняя дисциплина, фокусирование над задачей, ответственность за результат.</i>',
                            },
                            {
                                list: {
                                    title: 'Мы предлагаем:',
                                    items: [{
                                            label: 'Стабильная заработная плата по результатам собеседования, перспектива карьерного роста​​​​;'
                                        },
                                        {
                                            label: 'Оформление по ТК РФ и полностью «белая» заработная плата;'
                                        },
                                        {
                                            label: 'Гибкий график работы Пн-Пт. с 10 до 19 часов (обсуждается на собеседовании);'
                                        },
                                        {
                                            label: 'Работа только на постоянной основе и только в офисе (варианты удаленного или краткосрочного сотрудничества не рассматриваем);'
                                        },
                                    ]
                                },
                                text_end: 'Мы рассматриваем кандидатов без опыта. Главное - это уверенное знание английского языка и желание развиваться в данном направлении.',
                            },
                            {
                                list: {
                                    title: '',
                                    items: []
                                },
                                text_end: '<i>Используйте сопроводительное письмо как возможность продемонстрировать ваше знание иностранного языка. Это значительно ускорит процесс рассмотрения вашей кандидатуры.</i>',
                            },
                        ],
                    },

                    CareerPageFour: {
                        title: 'Младший специалист по арбитражу интернет-трафика',
                        lists: [{
                                list: {
                                    title: 'Чем предстоит заниматься:',
                                    items: [{
                                            label: 'Арбитраж десктопного трафика:',
                                            list: [{
                                                    label: 'Поиск и тестирование оферов;'
                                                },
                                                {
                                                    label: 'Совместная работа с дизайнерами и копирайтерами для создания промо-материалов (лендингов), их тестирование, увеличение CTR и CR, создание отчетности.'
                                                },
                                            ],
                                        },
                                        {
                                            label: 'Выявление основных конкурентов по каждому направлению, анализ активности;'
                                        },
                                        {
                                            label: 'Анализ промо-материалов основных конкурентов;'
                                        },
                                        {
                                            label: 'Анализ трендов на потребительском рынке.'
                                        },
                                    ]
                                },
                            },
                            {
                                list: {
                                    title: 'Мы будем рады видеть вас в нашей команде, если вы:',
                                    items: [{
                                            label: 'Имеете высшее или незаконченное высшее образование, желательно по тех. специальности (в том числе студенты);'
                                        },
                                        {
                                            label: 'Владеете Английским языком на среднем уровне (в основном, для чтения);'
                                        },
                                        {
                                            label: 'Имеете уверенный или профессиональный уровень владения компьютером (быстро печатаете, свободно ориентируетесь в ОС) и интернетом (умеете пользоваться поиском, почтой, мессенджерами);'
                                        },
                                        {
                                            label: 'Готовы работать в высоком темпе.'
                                        },
                                    ]
                                },
                                text_end: 'Если вы знаете, что такое арбитраж трафика - это будет преимуществом, если занимались лично (или плотно изучали вопрос) - большим преимуществом.',
                            },
                            {
                                list: {
                                    title: 'Мы предлагаем:',
                                    items: [{
                                            label: 'Стабильную заработная плата по результатам собеседования, перспектива карьерного роста​​;'
                                        },
                                        {
                                            label: 'Оформление по ТК РФ и полностью «белая» заработная плата;'
                                        },
                                        {
                                            label: 'Гибкий график работы Пн-Пт. с 10 до 19 часов (обсуждается на собеседовании);'
                                        },
                                        {
                                            label: 'Работа только на постоянной основе и только в офисе (варианты удаленного или краткосрочного сотрудничества не рассматриваем).'
                                        },
                                    ]
                                },
                            },
                        ],
                    },

                    CareerPageFive: {
                        title: 'Менеджер по продажам',
                        lists: [{
                                list: {
                                    title: 'Чем предстоит заниматься:',
                                    items: [{
                                            label: 'Переговоры с клиентами по скрипту;'
                                        },
                                        {
                                            label: 'Заполнения карты переговоров;'
                                        },
                                        {
                                            label: 'Поиск и ведение новых клиентов;'
                                        },
                                        {
                                            label: 'Проектная работа в команде.'
                                        },
                                    ]
                                },
                            },
                            {
                                list: {
                                    title: 'Мы будем рады видеть вас в нашей команде, если вы:',
                                    items: [{
                                            label: 'Знаете ПК на уровне продвинутого пользователя;'
                                        },
                                        {
                                            label: 'Имеете опыт работы в сфере продаж;'
                                        },
                                        {
                                            label: 'У вас есть опыт работы в call-центре.'
                                        },
                                    ]
                                },
                                text_end: '<b>Знание английского языка</b> будет вашим преимуществом.',
                            },
                            {
                                list: {
                                    title: 'Мы предлагаем:',
                                    items: [{
                                            label: 'Стабильная заработная плата по результатам собеседования, перспектива карьерного роста;​​​​​​​'
                                        },
                                        {
                                            label: 'Оформление по ТК РФ и полностью «белая» заработная плата;'
                                        },
                                        {
                                            label: 'Гибкий график работы Пн-Пт. с 10 до 19 часов (обсуждается на собеседовании);'
                                        },
                                        {
                                            label: 'Работа только на постоянной основе и только в офисе (варианты удаленного или краткосрочного сотрудничества не рассматриваем).'
                                        },
                                    ]
                                },
                            },
                        ],
                    },

                    Other: {
                        title: 'Мне нужна другая вакансия',
                        desc: "Не нашли подходящей вакансии? Отправьте нам свое резюме на почту: hh@bigdeal.agency. Оно будет сохранено в нашей базе данных. Мы свяжемся с вами, как только у нас появится подходящая для вас должность.",
                    },
                }
            }
        }
    },

    CONTACTS: {
        headful: {
            title: 'BigDeal Agency: Давайте поговорим!',
            description: 'Мы любим говорить с нашими клиентами и рассказывать о своей работе! Напишите нам, если у вас есть какие-либо вопросы о BigDeal Agency или наших услугах.'
        },

        route: {
            '/': {
                infoBlock: {
                    title: 'Давайте поговорим!',
                    desc: 'Мы любим говорить с нашими клиентами и рассказывать о своей работе! Напишите нам, если у вас есть какие-либо вопросы о BigDeal Agency или наших услугах.'
                }
            }
        }
    },

    MENU: {
        startChat: 'Начать общение с ботом',
        about: {
            title: 'О нас',
            items: [{
                    label: 'Вот это пушка'
                },
                {
                    label: 'Универсальность - наш конек',
                    innerList: [{
                            label: 'Брендинг'
                        },
                        {
                            label: 'Увеличение продаж'
                        },
                        {
                            label: 'Расширение бизнеса'
                        }
                    ]
                },
                {
                    label: 'Агенство, которое готово принять вызов'
                },
            ]
        },
        vision: {
            title: 'Концепция',
            items: [{
                    label: 'Все о планировании'
                },
                {
                    label: 'Создать медиаплан'
                },
                {
                    label: 'Проанализировать конкурентов'
                },
                {
                    label: 'Разработать стратегию'
                },
                {
                    label: 'Собрать команду'
                },
                {
                    label: 'Тест за тестом'
                },
                {
                    label: 'Достичь результатов'
                }
            ]
        },
        career: {
            title: 'Карьера',
            items: [{
                    label: 'Вакансии'
                },
                {
                    label: 'Отправить заявку'
                }
            ]
        },
        contacts: {
            title: 'Контакты',
            items: [{
                    label: 'Контактная информация'
                },
                {
                    label: 'Послать запрос'
                }
            ]
        },
    },

    TERMS: {
        cookiesPolicy: {
            mainTitle: 'Политика Cookie',
            parts: [{
                    title: 'Что такое файлы cookie?',
                    isList: false,
                    isPart: true,
                    paragraphs: [{
                            text: 'Cookie — текстовые файлы с небольшим объемом информации, которые передаются на браузер и хранятся на вашем компьютере, мобильном телефоне или другом устройстве, с которого вы заходите на сайт. Файлы cookie отправляют информацию на наш сайт каждый раз, когда вы его посещаете.'
                        },
                        {
                            text: 'Файлы cookie могут быть постоянными («постоянные»), которые сохраняются на компьютере до тех пор, пока пользователь их не удалит, или временными («сессионные»), которые действуют до тех пор, пока пользователь не закроет браузер.'
                        },
                        {
                            text: 'Кроме того, файлы cookie могут быть основными, которые устанавливаются с посещаемого сайта, и сторонними, которые устанавливаются иными лицами, не принадлежащими владельцу сайта.'
                        },
                    ]
                },
                {
                    title: 'Каким образом компания BigDeal Agency использует файлы cookie?',
                    isList: false,
                    isPart: true,
                    paragraphs: [{
                        text: 'Мы используем файлы cookie для улучшения функциональности нашего Сервиса, повышения эффективности навигации по страницам, запоминания настроек и максимального удобства пользователя. Мы также используем файлы cookie для того, чтобы анализировать, как пользователи пользуются нашим Сервисом, взаимодействуют с содержимым сайта и просматривают рекламу. В этих целях мы разрешаем одобренным третьим сторонам использовать файлы cookie и иные подобные технологии.'
                    }]
                },
                {
                    title: 'Используемые файлы cookie и их назначение',
                    isList: false,
                    isPart: true,
                    paragraphs: [{
                        text: 'Файлы cookie, используемые нами в рамках данного Сервиса, подразделяются на следующие категории:'
                    }]
                },
                {
                    title: 'Строго необходимые:',
                    isList: false,
                    isPart: true,
                    paragraphs: [{
                        text: 'Эти файлы cookie поддерживают навигацию по сайту и предоставление запрашиваемых услуг, например, для доступа к защищенным страницам. Файлы cookie этого типа применяются при регистрации пользователей и при входе в систему. Без них становятся недоступны запрашиваемые пользователем услуги. Данные файлы cookie являются основными и могут быть как постоянными, так и временными. Иными словами, без этих файлов cookie наш Сервис не будет работать должным образом.'
                    }]
                },
                {
                    title: 'Эксплуатационные:',
                    isList: false,
                    isPart: false,
                    paragraphs: [{
                        text: 'Эти файлы cookie собирают информацию об использовании сайта пользователями, например, данные о наиболее посещаемых страницах и продолжительности посещения. Цели использования этих файлов cookie:'
                    }, ]
                },
                {
                    isList: true,
                    isPart: false,
                    list: [{
                            item: 'получение статистики о пользовании нашим Сервисом'
                        },
                        {
                            item: 'оценка эффективности рекламных кампаний'
                        },
                    ]
                },
                {
                    isList: false,
                    isPart: true,
                    paragraphs: [{
                        text: 'Данные файлы cookie могут быть постоянными или временными, основными или сторонними. Они собирают информацию о посещении страниц и просмотре рекламы.'
                    }, ]
                },
                {
                    title: 'Функциональные:',
                    isList: false,
                    isPart: false,
                    paragraphs: [{
                        text: 'Эти файлы cookie позволяют сайту запоминать информацию о выбранных вами параметрах (например, имя пользователя, язык или страна, в которой вы находитесь) и обеспечивают доступ к расширенным и персонализированным возможностям. Эти файлы cookie также могут быть использованы для предоставления пользователям запрошенных ими услуг, например, поддерживают просмотр видео или публикации комментариев в блоге. Цели использования этих файлов cookie: '
                    }, ]
                },
                {
                    isList: true,
                    isPart: false,
                    list: [{
                            item: 'запоминание сведений о том, предоставлялись ли пользователю какие-либо услуги ранее'
                        },
                        {
                            item: 'повышение качества взаимодействия с сайтом в целом путем запоминания выбранных предпочтений'
                        },
                    ]
                },
                {
                    isList: false,
                    isPart: true,
                    paragraphs: [{
                        text: 'Данные файлы cookie бывают постоянными или временными, основными или сторонними. Они запоминают предоставленную вами информацию, повышая удобство пользования сайтом.'
                    }, ]
                },
                {
                    title: 'Другие сторонние файлы cookie:',
                    isList: false,
                    isPart: true,
                    paragraphs: [{
                        text: 'Некоторые страницы наших сайтов содержат материалы таких сервисов, как Landbot, YouTube, Facebook. Примите во внимание, что мы не можем управлять файлами cookie, используемые этими сервисами. Дополнительные сведения о них можно узнать, посетив соответствующий сайт третьей стороны.'
                    }, ]
                },
                {
                    title: 'Управление файлами cookie и их удаление',
                    isList: false,
                    isPart: false,
                    paragraphs: [{
                        text: 'Заблокировать или удалить файлы cookie, а также ограничить их действие можно в настройках вашего браузера. Необходимые для этого действия в разных браузерах могут быть разными. Чтобы просмотреть инструкции для вашего браузера, перейдите по одной из ссылок ниже. '
                    }, ]
                },
                {
                    isList: true,
                    isPart: false,
                    list: [{
                            item: 'Internet <a class="text__link" target="_blank" href="https://support.microsoft.com/en-us/help/17442/windows-internet-explorer-delete-manage-cookies">https://support.microsoft.com/en-us/help/17442/windows-internet-explorer-delete-manage-cookies</a>'
                        },
                        {
                            item: 'Firefox <a class="text__link" target="_blank" href="http://support.mozilla.org/en-US/kb/Cookies">http://support.mozilla.org/en-US/kb/Cookies</a>'
                        },
                        {
                            item: 'Google Chrome <a class="text__link" target="_blank" href="http://support.google.com/chrome/bin/answer.py?hl=en&answer=95647">http://support.google.com/chrome/bin/answer.py?hl=en&answer=95647</a>'
                        },
                        {
                            item: 'Opera <a class="text__link" target="_blank" href="https://www.opera.com/help/tutorials/security/privacy/">https://www.opera.com/help/tutorials/security/privacy/</a>'
                        },
                        {
                            item: 'Safari <a class="text__link" target="_blank" href="http://support.apple.com/kb/PH5042">http://support.apple.com/kb/PH5042</a>'
                        },
                    ]
                },
                {
                    isList: false,
                    isPart: false,
                    paragraphs: [{
                            text: 'Если вашего браузера нет в приведенном выше списке, для получения инструкций воспользуйтесь функцией справки в своем браузере.'
                        },
                        {
                            text: 'Обратите внимание, что определенные страницы наших сайтов доступны только при использовании файлов cookie. Отключение файлов cookie может привести к ограничению доступа к нашим материалам и неполноценному функционированию сайтов.'
                        },
                        {
                            text: 'Чтобы получить сведения об управлении файлами cookie в браузере мобильного устройства, просмотрите инструкции к этому устройству.'
                        },
                        {
                            text: 'Продолжая пользоваться этим сайтом, не изменив настройки своего браузера, вы тем самым соглашаетесь с тем, что мы можем использовать файлы cookie согласно положениям, описанным в данной политике.'
                        },
                    ]
                },
            ]
        },
        termsConditions: {
            mainTitle: 'Условия использования',
            parts: [{
                    title: 'Общие положения',
                    haveInnerList: false,
                    isVisibleList: true,
                    isVsibleAbcd: false,
                    list: [{
                            item: 'Добро пожаловать в BigDeal Agency («Веб-сайт»). Пожалуйста, ознакомьтесь с нашими Условиями использования.'
                        },
                        {
                            item: 'Доступ к этому Веб-сайту и его использование регулируются следующими положениями, условиями и уведомлениями («Условия использования»). В дополнение к этим Условиям использования ваше использование нашего веб-сайта подпадает под действие <a class="text__link" target="_blank" href="#/privacy-policy">Политики конфиденциальности</a> и <a class="text__link" target="_blank" href="#/cookie-policy">Политики файлов cookie</a>.'
                        },
                        {
                            item: 'Получая доступ к Веб-сайту, вы соглашаетесь с настоящими Условиями. Если у вас есть какие-либо вопросы, обратитесь в нашу службу поддержки клиентов, чьи данные указаны в конце настоящих Условий использования.'
                        },
                    ]
                },
                {
                    title: 'Использование веб-сайта',
                    haveInnerList: false,
                    isVisibleList: true,
                    isVsibleAbcd: false,
                    list: [{
                            item: 'Вы должны прочитать настоящие Условия и положения до использования Веб-сайта.'
                        },
                        {
                            item: 'Обратите внимание, что мы можем время от времени изменять Условия. Пересмотренные Условия будут доступны на Веб-сайте. Регулярно проверяйте наши Условия и положения, чтобы быть в курсе любых изменений, которые мы можем сделать. Используя данный Сервис, вы соглашаетесь соблюдать Условия использования. Если вы не полностью согласны с настоящими Условиями использования, не пользуйтесь Сервисом. Несоблюдение этих Условий использования может привести к прекращению вашего доступа к Сервису без уведомления.'
                        },
                    ]
                },
                {
                    title: 'Доступ к нашему сайту',
                    isVisibleList: true,
                    isVsibleAbcd: false,
                    haveInnerList: false,
                    list: [{
                            item: 'Вы не должны вмешиваться или нарушать работу Сайта или любых серверов или сетей, подключенных к Веб-сайту, в том числе путем передачи любых червей, вирусов, вредоносных программ, программ-шпионов или любого другого кода разрушительного, злонамеренного или разрушительного характера. Вы не можете вводить контент или код или иным образом изменять или мешать тому, как любая страница данного веб-сайта отображается в браузере или устройстве пользователя.'
                        },
                        {
                            item: 'Вы не должны получать доступ к Веб-сайту или любым Материалам (определенным ниже) с помощью средств, заранее не санкционированных нами письменно, такими как: автоматические устройства, скрипты, боты, пауки, сканеры или скребки (за исключением стандартных технологий поисковой системы ) и т.д. '
                        },
                        {
                            item: 'Вы не должны пытаться запретить другому пользователю Веб-сайта использоваться Веб-сайтом, и вы не должны поощрять или облегчать нарушение этих Положений и условий другими.'
                        },
                        {
                            item: 'Вы соглашаетесь не использовать Сайт для каких-либо незаконных или несанкционированных целей. Вы соглашаетесь соблюдать все законы, правила и положения, применимые к использованию вами Веб-сайта, включая, но не ограничиваясь авторским правом и другими законами об интеллектуальной собственности.'
                        },
                        {
                            item: 'Вы не должны изменять, изменять, адаптировать или изменять Веб-сайт или изменять, изменять или изменять другой веб-сайт, чтобы неточно подразумевать связь с Веб-сайтом или с нами.'
                        },
                        {
                            item: 'Вы не должны изменять или адаптировать Веб-сайт. '
                        },
                        {
                            item: 'Мы можем незамедлительно лишить вас доступа к Веб-сайту, предоставив вам письменное уведомления, если вы нарушите какие-либо из этих Положений и условий или любых других условий и политики, упомянутых в настоящих Условиях.'
                        },
                        {
                            item: 'Мы можем закрыть вам доступ к нашему Веб-сайту и / или вашей учетной записи в любое время и по любой причине, и мы не будем нести ответственности за любые возникающие убытки или ущерб в максимально возможной степени, допустимые законом.'
                        },
                        {
                            item: 'Вам запрещено использовать другие автоматические системы или программное обеспечение для извлечения содержимого или данных с нашего Веб-сайта, за исключением случаев, когда вы или какая-либо применимая третья сторона заключили с нами письменное соглашение, которое прямо разрешает такую деятельность.'
                        }
                    ]
                },
                {
                    title: 'Доступность нашего сайта',
                    haveInnerList: true,
                    isVisibleList: true,
                    isVsibleAbcd: false,
                    list: [{
                            item: 'Доступ к нашему сайту разрешен на временной основе. Мы регулярно обновляем Веб-сайт, так что мы можем в любой момент изменить его. Мы оставляем за собой право удалить или изменить Веб-сайт без предварительного уведомления. Мы не будем нести ответственности перед вами по любой причине, если Веб-сайт будет недоступен в любое время в течение любого времени.'
                        },
                        {
                            item: 'Вы несете ответственность за принятие всех необходимых мер для доступа к нашему сайту. Вы также несете ответственность за то, чтобы все лица, обращающиеся к нашему сайту через ваше интернет-соединение, знали об этих Условиях использования.'
                        },
                        {
                            item: 'Вы признаете, что мы не можем гарантировать, что наш веб-сайт:',
                            innerlist: [{
                                    item: 'будет совместимым со всеми или любым оборудованием или программным обеспечением, которое вы можете использовать;'
                                },
                                {
                                    item: 'будет доступным все время или в любое конкретное время;'
                                },
                                {
                                    item: 'будет точным и актуальным;'
                                },
                                {
                                    item: 'будет свободным от вирусов, электронных ошибок, троянских коней или других вредоносных компонентов, и вы должны принять ваши собственные меры предосторожности соответствующим образом.'
                                },
                            ]
                        },
                    ],
                },
                {
                    title: 'Вы также признаете, что:',
                    isVisibleList: true,
                    isVsibleAbcd: true,
                    list: [{
                            item: 'нам может потребоваться время от времени удалять определенный контент с Веб-сайта'
                        },
                        {
                            item: 'мы не можем гарантировать скорость или безопасность нашего веб-сайта'
                        },
                        {
                            item: 'мы не несем ответственности за любой ущерб или убытки, которые вы можете понести прямо или косвенно в результате любой вирусной атаки, которая может быть прослежена на нашем веб-сайте в максимально возможной степени, допустимой законом.'
                        }
                    ],
                    paragraphs: [{
                        text: 'Мы также не будем нести ответственности перед вами за любую неспособность поддерживать сайт.'
                    }]
                },
                {
                    title: 'Ваша конфиденциальность и файлы cookie',
                    isVisibleList: false,
                    isVsibleAbcd: false,
                    paragraphs: [{
                        text: 'Конфиденциальность ваших личных данных важна для нас. Пожалуйста, ознакомьтесь с нашей Политикой конфиденциальности, которая является частью Условий использования, для получения подробной информации о том, как мы будем обрабатывать ваши персональные данные. На нашем веб-сайте также используются куки-файлы и аналогичные технологии. Ознакомьтесь с нашей <a class="text__link" target="_blank" href="#/cookie-policy">Политикой Cookie</a>, которая является частью <a class="text__link" target="_blank">Условий использования</a>, для получения более подробной информации о том, как мы используем куки-файлы и аналогичные технологии.'
                    }]
                },
                {
                    title: 'Сторонние веб-сайты и сервисы',
                    haveInnerList: false,
                    isVisibleList: true,
                    isVsibleAbcd: false,
                    list: [{
                            item: 'Наш сайт и / или Материалы могут содержать ссылки на сторонние веб-сайты и службы. Если вы решите посетить какой-либо сторонний сайт или использовать сторонний сервис, вы делаете это на свой страх и риск. Мы не несем ответственности за содержание или мнения, выраженные на таких сайтах или услугах. Ссылки не подразумевают, что мы, или наш Веб-сайт, связаны с такими сайтами или услугами.'
                        },
                        {
                            item: 'Ваш просмотр и взаимодействие на любом другом веб-сайте или использование других сервисов, включая веб-сайты и службы, имеющие ссылку на наш веб-сайт, подчиняются правилам и правилам этого оператора. Прежде чем продолжить, ознакомьтесь с этими правилами и политикой.'
                        },
                    ]
                },
                {
                    title: 'Вопросы и жалобы',
                    haveInnerList: false,
                    isVisibleList: true,
                    isVsibleAbcd: false,
                    list: [{
                            item: 'Если у вас есть вопрос или жалоба на наш сайт (включая материалы, которые появляются на нашем веб-сайте), пожалуйста, свяжитесь с нашей службой поддержки клиентов по адресу Contact@BigDeal Agency, и мы постараемся ответить на ваш вопрос или разрешить любую жалобу как можно скорее.'
                        },
                        {
                            item: 'Если у вас есть предложения по улучшению или дополнениям, которые вы хотели бы видеть на веб-сайте, напишите нам по адресу Contact@BigDeal Agency.'
                        },
                    ],
                    paragraphs: [{
                        text: 'BigDeal Agency - это бренд, принадлежащий TecophoneLTD. Почтовый адрес TecophoneLTD - 8 Kennedy street, 3th floor, office 306, 1087, Nicosia, Cyprus.'
                    }]
                },


                 {
                     title: 'Политика отмены и возврата денежных средств',
                     isVisibleList: false,
                     isVsibleAbcd: false,
                     paragraphs: [{
                             text: 'Пользуясь услугами BigDeal Agency, Вы выражаете свое согласие с Политикой отмены и возврата денег данного Сайта (далее по тексту – Сайт). Сайт оставляет за собой право вносить изменения в Политику отмены и возврата денег по своему усмотрению. Вы соглашаетесь периодически посещать данную страницу, чтобы ознакомиться с актуальными положениями, которых Вы должны придерживаться. 	 Используя Cайт, вы принимаете эту политику возврата. Если вы не согласны с Политикой возврата, пожалуйста, не используйте Сайт.'
                         },
                         {
                             text: 'BigDeal Agency может изменить свою Политику возврата в любое время. Вы несете ответственность за регулярное ознакомление с Сайтом для своевременного уведомления о таких изменениях. Считается, что вы приняли такие поправки, продолжая использовать Сайт или вашу Учетную запись после того, как такие поправки были опубликованы или информация о них была отправлена вам.'
                         },
                         {
                             text: "Если вы недовольны трафиком, предоставляемым BigDeal Agency, мы вернем вам средства, которые вы занесли на счет в системе, но не успели израсходовать. При этом, вы не предъявляете претензий в отношении возврата средств, потраченных во время рекламной кампании. Если же вы хотите получить возврат уже израсходованных средств из-за качества трафика, вы должны предоставить BigDeal Agency доказательства низкого качества трафика, полученного за запрошенный период (подробный отчет и т. д.)."
                         },
                     ]
                 },

                 {
                     title: 'Как запросить возврат денежных средств.',
                     haveInnerList: true,
                     isVisibleList: true,
                     isVsibleAbcd: false,
                     list: [{
                         item: 'Напишите нам на почту: contact@bigdeal.agency.',
                         innerlist: [{
                                 item: 'Свой логин;'
                             },
                             {
                                 item: 'Причины, по которым вы хотели бы, чтобы мы рассмотрели возврат;'
                             },
                             {
                                 item: 'Подтверждение низкого качества трафика (в случае запроса на возврат уже израсходованных средств).'
                             },
                         ]
                     }, ],
                 },

                 {
                     title: 'Вопросы:',
                     haveInnerList: false,
                     isVisibleList: false,
                     isVsibleAbcd: false,
                     paragraphs: [{
                             text: 'Если у вас есть какие-либо вопросы относительно данной Политики возмещения, пожалуйста, свяжитесь с нами по электронной почте: contact@bigdeal.agency.'
                         },
                         {
                             text: 'BigDeal Agency рассмотрит вопрос о предоставлении возмещения, запрошенного в указанные выше сроки и отвечающего критериям, и предоставит возмещение по своему усмотрению. Ничто в настоящем документе не гарантирует того, что BigDeal Agency вернет денежные средства в обязательном порядке.'
                         },
                     ]
                 },


            ]
        },
        privacyPolicy: {
            mainTitle: 'Политика обработки персональных данных',
            parts: [{
                title: 'Общие положения',
                isPart: true,
                paragraphs: [{
                    text: 'BigDeal Agency (далее по тексту – Оператор) ставит соблюдение прав и свобод граждан одним из важнейших условий осуществления своей деятельности.'
                },
                {
                    text: 'Политика Оператора в отношении обработки персональных данных (далее по тексту — Политика) применяется ко всей информации, которую Оператор может получить о посетителях веб-сайта BigDeal Agency. Персональные данные обрабатывается в соответствии с ФЗ «О персональных данных» № 152-ФЗ. '
                }
                ]
            },
            {
                title: 'Основные понятия, используемые в Политике:',
                isPart: true,
                paragraphs: [{
                    text: 'Веб-сайт - совокупность графических и информационных материалов, а также программ для ЭВМ и баз данных, обеспечивающих их доступность в сети интернет по сетевому адресу BigDeal Agency;'
                },
                {
                    text: 'Пользователь – любой посетитель веб-сайта BigDeal Agency;'
                },
                {
                    text: 'Персональные данные – любая информация, относящаяся к Пользователю веб-сайта BigDeal Agency;'
                },
                {
                    text: 'Обработка персональных данных - любое действие с персональными данными, совершаемые с использованием ЭВМ, равно как и без их использования;'
                },
                {
                    text: 'Обезличивание персональных данных – действия, результатом которых является невозможность без использования дополнительной информации определить принадлежность персональных данных конкретному Пользователю или лицу;'
                },
                {
                    text: 'Распространение персональных данных – любые действия, результатом которых является раскрытие персональных данных неопределенному кругу лиц;'
                },
                {
                    text: 'Предоставление персональных данных – любые действия, результатом которых является раскрытие персональных данных определенному кругу лиц;'
                },
                {
                    text: ' Уничтожение персональных данных – любые действия, результатом которых является безвозвратное уничтожение персональных на ЭВМ или любых других носителях.'
                },
                ]
            },
            {
                title: 'Обрабатываемые данные',
                isPart: true,
                paragraphs: [{
                    text: 'Оператор может обрабатывать следующие персональные данные:'
                },
                {
                    text: 'Адрес электронной почты Пользователя'
                },
                {
                    text: 'Номер телефона Пользователя'
                },
                {
                    text: 'Фамилию, имя, отчество Пользователя'
                },
                {
                    title: 'Основные понятия, используемые в Политике:',
                    isPart: true,
                    paragraphs: [{
                            text: 'Веб-сайт - совокупность графических и информационных материалов, а также программ для ЭВМ и баз данных, обеспечивающих их доступность в сети интернет по сетевому адресу BigDeal Agency;'
                        },
                        {
                            text: 'Пользователь – любой посетитель веб-сайта BigDeal Agency;'
                        },
                        {
                            text: 'Персональные данные – любая информация, относящаяся к Пользователю веб-сайта BigDeal Agency;'
                        },
                        {
                            text: 'Обработка персональных данных - любое действие с персональными данными, совершаемые с использованием ЭВМ, равно как и без их использования;'
                        },
                        {
                            text: 'Обезличивание персональных данных – действия, результатом которых является невозможность без использования дополнительной информации определить принадлежность персональных данных конкретному Пользователю или лицу;'
                        },
                        {
                            text: 'Распространение персональных данных – любые действия, результатом которых является раскрытие персональных данных неопределенному кругу лиц;'
                        },
                        {
                            text: 'Предоставление персональных данных – любые действия, результатом которых является раскрытие персональных данных определенному кругу лиц;'
                        },
                        {
                            text: ' Уничтожение персональных данных – любые действия, результатом которых является безвозвратное уничтожение персональных на ЭВМ или любых других носителях.'
                        },
                    ]
                },
                {
                    title: 'Обрабатываемые данные',
                    isPart: true,
                    paragraphs: [{
                            text: 'Оператор может обрабатывать следующие персональные данные: <br/> Проверьте, соответствует ли список ниже тем данным, которые собираете вы.Если нет, добавьте / удалите данные'
                        },
                        {
                            text: 'Адрес электронной почты Пользователя'
                        },
                        {
                            text: 'Номер телефона Пользователя'
                        },
                        {
                            text: 'Фамилию, имя, отчество Пользователя'
                        },
                        {
                            text: 'Также на сайте происходит сбор и обработка обезличенных данных о посетителях (в т.ч. файлов «cookie») с помощью сервисов интернет-статистики (Яндекс Метрика и Гугл Аналитика и других). '
                        },
                    ]
                },
                {
                    title: 'Цели обработки персональных данных',
                    isPart: true,
                    paragraphs: [{
                            text: 'Цель обработки адреса электронной почты, номера телефона, фамилии, имени, отчества Пользователя - уточнение деталей заказа. Также Оператор имеет право направлять Пользователю уведомления о новых продуктах и услугах, специальных предложениях и различных событиях. Пользователь всегда может отказаться от получения информационных сообщений, направив Оператору письмо на адрес Contact@BigDeal Agency'
                        },
                        {
                            text: 'Обезличенные данные Пользователей, собираемые с помощью сервисов интернет-статистики, служат для сбора информации о действиях Пользователей на сайте, улучшения качества сайта и его содержания.'
                        },
                    ]
                },
                {
                    title: 'Правовые основания обработки персональных данных',
                    isPart: true,
                    paragraphs: [{
                            text: 'Оператор обрабатывает персональные данные Пользователя только в случае их отправки Пользователем через формы, расположенные на сайте BigDeal Agency. Отправляя свои персональные данные Оператору, Пользователь выражает свое согласие с данной Политикой.'
                        },
                        {
                            text: 'Оператор обрабатывает обезличенные данные о Пользователе в случае, если это разрешено в настройках браузера Пользователя (включено сохранение файлов «cookie» и использование технологии JavaScript). '
                        },
                    ]
                },
                {
                    title: 'Порядок сбора, хранения, передачи и других видов обработки персональных данных',
                    isPart: true,
                    paragraphs: [{
                            text: 'Оператор обеспечивает сохранность персональных данных и принимает все возможные меры, исключающие доступ к персональным данным неуполномоченных лиц.'
                        },
                        {
                            text: 'Персональные данные Пользователя никогда, ни при каких условиях не будут переданы третьим лицам, за исключением случаев, связанных с исполнением действующего законодательства.'
                        },
                        {
                            text: 'В случае выявления неточностей в персональных данных, Пользователь может актуализировать их, направив Оператору уведомление с помощью электронной почты на электронный адрес Оператора Contact@BigDeal Agency, с пометкой «Актуализация персональных данных»'
                        },
                        {
                            text: 'Срок обработки персональных данных является неограниченным. Пользователь может в любой момент отозвать свое согласие на обработку персональных данных, направив Оператору уведомление с помощью электронной почты на электронный адрес Оператора Contact@BigDeal Agency, с пометкой «Отзыв согласия на обработку персональных данных». '
                        },
                    ]
                },
                {
                    title: 'Заключительные положения',
                    isPart: true,
                    paragraphs: [{
                            text: 'Пользователь может получить любые разъяснения по интересующим вопросам, касающимся обработки его персональных данных, обратившись к Оператору с помощью электронной почты Contact@BigDeal Agency.'
                        },
                        {
                            text: 'В данном документе будут отражены любые изменения политики обработки персональных данных Оператором. В случае существенных изменений Пользователю может быть выслана информация на указанный им электронный адрес.'
                        },
                    ]
                },
            ]
        },
        ],
    },

        PAGE_NOT_FOUND: {
            title: "Страница <br> не найдена",
            smallText: "К сожалению, страница, которую вы ищете, не существует.",
            btnText: "На главную"
        }
    }
}